import { Button, Icon } from "@outschool/backpack";
import { faEnvelope } from "@outschool/icons";
import { Trans, useTranslation } from "@outschool/localization";
import { IntegrationCategory, useTrackEvent } from "@outschool/ui-analytics";
import { useSession } from "@outschool/ui-auth";
import { HelpLink } from "@outschool/ui-components-website";
import { Screen } from "@outschool/ui-utils";
import React from "react";
import { useLocation } from "react-router";

import { TeacherPublicProfileQueryQuery } from "../../../../../shared/generated/graphql";
// @ts-ignore - JSX import
import MessageModal from "../../../MessageModal";

type MessageModalContainerProps = {
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  leader: TeacherPublicProfileQueryQuery["publicProfile"]["leader"];
};

export const MessageModalContainer: React.FunctionComponent<
  MessageModalContainerProps
> = ({ leader }) => {
  const location = useLocation();
  const isMobile = Screen.useIsMobile();
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);
  const { isLoggedIn, currentUser } = useSession();
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\MessageModalContainer"
  );

  return (
    <MessageModal
      renderButton={(open: $TSFixMe) => (
        <Button
          variant="contained"
          onClick={open}
          size="medium"
          sx={{
            width: isMobile ? "unset" : "150px"
          }}
          startIcon={<Icon icon={faEnvelope} />}
        >
          {t("Message")}
        </Button>
      )}
      user={currentUser}
      location={location}
      requireLogin={true}
      isLoggedIn={isLoggedIn}
      viewName="sendMessageToLeader"
      heading={t("Ask the teacher")}
      prompt={(close: $TSFixMe) => (
        <React.Fragment>
          <Trans t={t}>
            Ask {{ leaderName: leader.name }} about their classes or background.
            For questions about the Outschool website,{" "}
            <HelpLink onClick={close} sx={{ width: "fit-content" }}>
              use Outschool Help
            </HelpLink>
            .
          </Trans>
        </React.Fragment>
      )}
      recipients={[leader]}
      onMessageCreated={() => {
        trackAdEvent("Message Teacher");
      }}
      showFromAndTo
      subject={t("Question for {{leaderName}}", { leaderName: leader.name })}
      context={{
        action: t("Ask a Question"),
        leaderUid: leader.uid,
        leaderName: leader.name,
        subject: t("Question for {{leaderName}}", { leaderName: leader.name })
      }}
    />
  );
};
